import { 
    FETCH_BUSINESS_CASE_FAILURE,
    FETCH_BUSINESS_CASE_REQUEST,
    FETCH_BUSINESS_CASE_SUCCESS
} from "../../actions/opportunities/businessCaseActions";

  const initialState = {
    businessCaseLoading: false,
    businessCaseData: [],
    businessCaseError: null,
  };

  const businessCaseReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_BUSINESS_CASE_REQUEST:
        return { ...state, businessCaseLoading: true , payload: action.payload};
      case FETCH_BUSINESS_CASE_SUCCESS:
        return { ...state, businessCaseLoading: false, businessCaseData: action.payload };
      case FETCH_BUSINESS_CASE_FAILURE:
        return { ...state, businessCaseLoading: false, businessCaseError: action.payload };
      default:
        return state;
    }
  };
  
  export default businessCaseReducer;